import { render, staticRenderFns } from "./RetrievalQuery.vue?vue&type=template&id=1327b8b8&"
import script from "./RetrievalQuery.vue?vue&type=script&lang=ts&"
export * from "./RetrievalQuery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports